import './index.css';
import {Route, Routes} from "react-router-dom";

export default function App() {
  return <Routes>
    <Route path="*" element={
      <section className="home">
        <article
            className="img-logo"
        />
      </section>
    }/>
  </Routes>
}